export default "__VITE_ASSET__BUoqRiPE__"